export const Config = {
  baseFolder: '/dot/',
  // baseFolder: '/',
  //apiRoot: 'http://localhost:9000/api/v1/',
  apiRoot: 'https://admin.udruzenjeosiguravaca.net/api/v1/',
  // apiRoot: 'https://uosportal.normasoft.net/api/v1/',
  protectionOff: false,
  reCaptchaKey: '6LfIUegnAAAAAHEGLrGVf15ppxIhtSP_vxPRGFcJ'
};

export const currentEventId = '69b78c98-e507-4fe7-9c33-a9f02f507e89';
